// extracted by mini-css-extract-plugin
export default {"DragBar":"DragBar_gO8OK_v17-8-1"};